<app-loading *ngIf="!contentReady"></app-loading>

<div class="container mb-4" *ngIf="contentReady">
  <div class="row additem-content">
    <h2 class="additemhead">
      @if(isUpdatePage){
        تعديل وظيفة
      }
      @else{
        إضافة وظيفة جديدة
      }
    </h2>

    <form class="form" [formGroup]="data" (ngSubmit)="onSubmit()">
      <div class="d-flex flex-column flex-sm-row justify-content-center">
        <div class="col-12 form-container">

          <!-- Job Titles -->
          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="title_en"
              placeholder="عنوان الوظيفة باللغة الإنجليزية"
            />
          </div>

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="title_ar"
              placeholder="عنوان الوظيفة باللغة العربية"
            />
          </div>

          <!-- Relations -->
<div class="form-group dropdown-container">
  <select formControlName="company_id">
    <option [ngValue]="null">اختر الشركة</option>

    <option *ngFor="let company of companies" [ngValue]="company.id">
      {{ company.name }}
    </option>
  </select>
</div>

          <!-- <div class="form-group">
            <input
              class="input"
              type="number"
              formControlName="doctor_id"
              placeholder="رقم الطبيب - اختياري"
            />
          </div> -->

<div class="form-group dropdown-container">
  <select formControlName="complex_request_id">
    <option [ngValue]="null">اختر الطلبية </option>

    <option *ngFor="let complex of complexRequests" [ngValue]="complex.id">
      {{ complex.complex_name }} - {{ complex.complex_location }}
    </option>
  </select>
</div>

<!-- Location -->
<div class="form-group dropdown-container">
  <select formControlName="country_id" (change)="onCountryChange()">
    <option [ngValue]="null">اختر الدولة</option>

    <option *ngFor="let country of countries" [ngValue]="country.id">
      {{ country.country_name_ar }} - {{ country.country_name_en }}
    </option>
  </select>
</div>

<div class="form-group dropdown-container">
  <select formControlName="city_id" [disabled]="!data.get('country_id')?.value">
    <option [ngValue]="null">اختر المدينة</option>

    <option *ngFor="let city of cities" [ngValue]="city.id">
      {{ city.city_name_ar }} - {{ city.city_name_en }}
    </option>
  </select>
</div>

          <!-- Work Model -->
          <div class="form-group dropdown-container">
            <select formControlName="work_model">
              <option value="on_site">من مقر العمل</option>
              <option value="remote">عن بُعد</option>
              <option value="hybrid">هجين</option>
            </select>
          </div>
<!-- Job Type -->
<div class="form-group dropdown-container">
  <select formControlName="job_type">
    <option value="any">الكل</option>
    <option value="fordoctors">للأطباء</option>
    <option value="fordentist">لأطباء الأسنان</option>
  </select>
</div>
          <!-- Employment Type -->
          <div class="form-group dropdown-container">
            <select formControlName="employment_type">
              <option value="full_time">دوام كامل</option>
              <option value="part_time">دوام جزئي</option>
              <option value="contract">تعاقد</option>
              <option value="internship">تدريب</option>
            </select>
          </div>

          <!-- Description -->
          <div class="form-group">
            <textarea
              class="input"
              rows="6"
              formControlName="description"
              placeholder="وصف الوظيفة"
            ></textarea>
          </div>

          <div class="form-group">
            <textarea
              class="input"
              rows="6"
              formControlName="responsibilities"
              placeholder="المهام والمسؤوليات"
            ></textarea>
          </div>

          <!-- Salary -->
          <div class="form-group dropdown-container">
            <select formControlName="salary_type">
              <option value="competitive">راتب تنافسي</option>
              <option value="fixed">راتب ثابت</option>
              <option value="range">نطاق راتب</option>
              <option value="negotiable">قابل للتفاوض</option>
            </select>
          </div>

          <div class="form-group">
            <input
              class="input"
              type="number"
              formControlName="salary_min"
              placeholder="الحد الأدنى للراتب"
            />
          </div>

          <div class="form-group">
            <input
              class="input"
              type="number"
              formControlName="salary_max"
              placeholder="الحد الأقصى للراتب"
            />
          </div>

          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="salary_currency"
              placeholder="عملة الراتب"
            />
          </div>
<div class="form-group">
  <input
    class="input"
    type="text"
    formControlName="salary_currency_ar"
    placeholder="عملة الراتب بالعربي"
  />
</div>
          <div class="form-group">
            <input
              class="input"
              type="text"
              formControlName="salary_note"
              placeholder="ملاحظات الراتب"
            />
          </div>

          <!-- Flags -->
          <div class="form-group check-row">
            <input type="checkbox" formControlName="exam_required" />
            <span>مطلوب اختبار</span>
          </div>

          <div class="form-group check-row">
            <input type="checkbox" formControlName="personality_assessment_required" />
            <span>مطلوب تقييم شخصية</span>
          </div>

          <!-- Status -->
          <div class="form-group dropdown-container">
            <select formControlName="status">
              <option value="draft">مسودة</option>
              <option value="published">منشورة</option>
              <option value="closed">مغلقة</option>
            </select>
          </div>

<div class="form-group">
  <label class="field-label">تاريخ نشر الوظيفة</label>

  <div class="arabic-date-field" (click)="openDatePicker(datePickerInput)">
    <input
      class="input arabic-date-input"
      type="text"
      readonly
      [value]="postedAtArabic || 'اختر تاريخ ووقت النشر'"
    />

    <span class="calendar-icon">📅</span>

    <input
      #datePickerInput
      class="real-date-input"
      type="datetime-local"
      [value]="data.get('posted_at')?.value"
      (change)="onPostedAtChange($event)"
    />
  </div>
</div>

          <!-- Skills -->
<!-- Skills -->
<div class="form-group skills-section" [formGroup]="newSkillForm">
  <h4>المهارات المطلوبة</h4>

  <!-- Category Tags -->
  <div class="category-tags">
    <button
      type="button"
      class="category-tag"
      *ngFor="let category of skillCategories"
      [class.active]="selectedSkillCategory === category.value"
      (click)="selectSkillCategory(category.value)"
    >
      {{ category.label }}
    </button>
  </div>

  <!-- Skills Under Selected Category -->
  <div class="skills-box" *ngIf="filteredSkills.length > 0">
    <label class="skill-item" *ngFor="let skill of filteredSkills">
      <input
        type="checkbox"
        [checked]="isSkillSelected(skill.id)"
        (change)="toggleSkill(skill.id, $event)"
      />

      <span>{{ getSkillName(skill) }}</span>
    </label>
  </div>

  <p class="empty-text" *ngIf="filteredSkills.length === 0">
    لا توجد مهارات داخل هذا التصنيف
  </p>

  <!-- Add New Skill -->
  <div class="add-skill-inline">
    <h5>إضافة مهارة جديدة داخل التصنيف</h5>

    <input
      class="input"
      type="text"
      formControlName="name_ar"
      placeholder="اسم المهارة بالعربي"
    />

    <input
      class="input"
      type="text"
      formControlName="name_en"
      placeholder="اسم المهارة بالإنجليزي"
    />

    <button
      type="button"
      class="small-add-btn add-skill-btn"
      [disabled]="newSkillForm.invalid || addingSkill"
      (click)="addSkillFromJobForm()"
    >
      @if(addingSkill){
        جاري إضافة المهارة...
      }
      @else{
        إضافة وتحديد المهارة
      }
    </button>
  </div>
</div>

          <!-- Requirements -->
          <div class="form-group requirements-section">
            <div class="requirements-head">
              <h4>متطلابات الوظيفة</h4>

              <button type="button" class="small-add-btn" (click)="addRequirement()">
                + إضافة
              </button>
            </div>

            <div formArrayName="requirements">
              <div
                class="requirement-card"
                *ngFor="let req of requirements.controls; let i = index"
                [formGroupName]="i"
              >
                <input
                  class="input"
                  type="text"
                  formControlName="requirement_text"
                  placeholder="اكتب متطلب الوظيفة"
                />

                <select class="input" formControlName="requirement_type">
                  <option value="education">المؤهل الدراسي</option>
                  <option value="experience">الخبرة</option>
                  <option value="certificate">الشهادة</option>
                  <option value="language">اللغة</option>
                  <option value="other">أخرى</option>
                </select>

                <div class="check-row requirement-check">
                  <input type="checkbox" formControlName="is_required" />
                  <span>متطلب أساسي</span>
                </div>

                <button
                  type="button"
                  class="remove-btn"
                  (click)="removeRequirement(i)"
                  *ngIf="requirements.length > 1"
                >
                  حذف
                </button>
              </div>
            </div>
          </div>

          <!-- Submit -->
          <div class="form-group">
            <button
              type="submit"
              class="fromsave accont"
              [disabled]="data.invalid || isSubmitting"
            >
              @if(isSubmitting){
                جاري الحفظ...
              }
              @else if(isUpdatePage){
                تعديل الوظيفة
              }
              @else{
                إنشاء الوظيفة
              }
            </button>
          </div>

        </div>
      </div>
    </form>
  </div>
</div>